
import { mapState } from "vuex";

const CURRENCY_LOCALE_MAP = {
  INR: "en-IN",
  EUR: "en-EU",
  AED: "ar-AE"
};

// option 1: get user's country from backend
// option 2: get country code from phone number using libphonejs
// option 3: maintain a currency-locale-map

export default {
  props: {
    amount: {
      type: String | Number,
      required: true,
      default: ""
    },
    isPaisa: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState("restaurant", ["locationDetails"]),
    amountValue() {
      return this.isPaisa ? this.amount / 100 : this.amount;
    },
    formattedAmount() {
      try {
        const currencyLocale = this.locationDetails?.location_currency || "INR";
        const formatter = new Intl.NumberFormat(
          CURRENCY_LOCALE_MAP[currencyLocale],
          {
            style: "currency",
            currency: currencyLocale,
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          }
        );

        return formatter.format(this.amountValue);
      } catch (error) {
        console.error("Error in formatting amount", error);
        return this.amountValue;
      }
    }
  }
};
